const t = {
  name: "ChevronsUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 8.41436L16.0002 12.4144L17.4144 11.0002L12.0002 5.58594L6.58594 11.0002L8.00015 12.4144L12.0002 8.41436Z" fill="currentColor"/>
<path d="M12.0002 14.4144L16.0002 18.4144L17.4144 17.0002L12.0002 11.5859L6.58594 17.0002L8.00015 18.4144L12.0002 14.4144Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ChevronsUp
};
